import { render, staticRenderFns } from "./LaudoTecnicoAgricola.vue?vue&type=template&id=615f6cd5&scoped=true&lang=pug"
import script from "./LaudoTecnicoAgricola.vue?vue&type=script&lang=js"
export * from "./LaudoTecnicoAgricola.vue?vue&type=script&lang=js"
import style0 from "./LaudoTecnicoAgricola.vue?vue&type=style&index=0&id=615f6cd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f6cd5",
  null
  
)

export default component.exports